<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-info">
          <div>
            <!-- <img alt="full_screen_required" src="../assets/switch_tab.svg" /> -->
          </div>
          <div class="modal-text">
            You violated test rules {{$store.state.maxAllowedEventViolations}} {{getMsgText($store.state.maxAllowedEventViolations)}}, hence ending your test
          </div>
        </div>
        <div class="modal-footer">
          <button class="go-back-button" @click="closeTest">
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from '../services/api.service'
export default {
  name: 'TestViolatePopup',
  props: {
    switchCount: Number,
  },
  created() {
    if(this.$store.state.currentStep !== 'test-rules-violated' || this.$store.state.testeeStatus === 'COMPLETED'){
      return;
    }
    api.postPing(this.$store.state.test.testId, this.$store.state.userId, this.$store.state.testRestartCount).then(() => {
      console.log('ok')
    })
    api.postEndTime(this.$store.state.test.testId, this.$store.state.userId).then(() => {
      console.log('Test Ended')
      this.$store.commit('setTesteeStatus', 'COMPLETED')
    })
    console.log('Ending Test!')
    clearInterval(this.$store.state.pingTimer)
    clearInterval(this.$store.state.timer)
  },
  methods: {
    closeTest(){
      this.$store.commit('setCurrentStep', 'feedback')
      this.$router.replace({path: '/feedback'})
    },
    getMsgText(violationCount) {
      return violationCount === 1 ? ' more time' : ' more times'
    },
  },
}
</script>

<style scoped>
.go-back {
  margin-top: 20px;
  text-align: center;
}

.go-back-button {
  border: 1px solid #0988f4;
  border-radius: 2px;
  height: 40px;
  font-family: Roboto-Bold;
  font-size: 14px;
  color: white;
  background-color: #0988f4;
  cursor: pointer;
  outline: #0988f4;
  padding: 10px 16px;
}

.modal-mask {
  position: fixed;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* background: rgba(0,0,0,0.4); */
  background: #374868;
  display: table;
  transition: opacity 0.3s ease;
  margin-top: 64px;
}

.modal-wrapper {
  margin-top: 88px;
}

.modal-container {
  background: #ffffff;
  border: 1px solid #d9d9d9;
  box-shadow: 0 3px 0 0 rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  width: 500px;
  margin: auto;
  display: flex;
  flex-direction: column;
}

.modal-info {
  display: flex;
  padding: 32px;
}

.modal-text {
  margin: auto;
}

.modal-info img {
  height: 100px;
  width: 80px;
}

.modal-text h4 {
  font-family: 'Roboto-Light';
  font-size: 24px;
  color: #616262;
  letter-spacing: 0;
}

.modal-text span {
  display: block;
  margin-top: 10px;
  font-family: 'Roboto-Regular';
  font-size: 14px;
  color: #616262;
  letter-spacing: 0;
}

.modal-footer {
  border-top: 1px solid #d9d9d9;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
